import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Appointment } from '../../core/models/appointment.model';
import { EmergencyContact } from '../../core/models/emergency-contact.model';
import { AgePipe } from '../../core/pipes/age.pipe';

@Component({
  selector: 'app-patient-file-summary',
  imports: [DatePipe, AgePipe],
  templateUrl: './patient-file-summary.html',
  styleUrl: './patient-file-summary.scss',
})
export class PatientFileSummary {
  @Input() booking: Appointment | null | undefined;
  @Input() emergencyContact: EmergencyContact | null = null;
}
